import { render } from "./PinsIcon.vue?vue&type=template&id=66afbae9"
const script = {}
script.render = render

export default script